import type { FC } from 'react';
import { ICON_COMPONENTS } from './registry';
import type { IconName } from './types';

export type { IconName };

interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
  title?: string;
  color?: string;
}

export const Icon: FC<IconProps> = ({ name, size = 24, className, title, color }) => {
  const Component = ICON_COMPONENTS[name];
  if (!Component) return null;

  return (
    <Component
      width={size}
      height={size}
      className={className}
      color={color}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      focusable="false"
      data-icon={name}
    >
      {title && <title>{title}</title>}
    </Component>
  );
};
